import React from "react";
import classNames from "classnames";
import setHelperText from "../helpers/setHelperText";
import { WrappedFieldInputProps, WrappedFieldMetaProps } from "redux-form";

export interface SelectionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label: string;
  type: string;
  input?: Partial<WrappedFieldInputProps>;
  helperText?: string;
  helperTextEnabled?: boolean;
  disabled?: boolean;
  meta: Partial<WrappedFieldMetaProps>;
  readOnly?: boolean;
}

export const Selection: React.FC<SelectionProps> = (props: SelectionProps): JSX.Element => {
  const {
    id,
    label,
    type,
    helperText,
    helperTextEnabled = true,
    disabled,
    meta: { touched, error },
    input,
    readOnly,
    ...rest
  } = props;

  const formElemRootClasses = classNames(
    "caprx-f-elem-root",
    "caprx-f-elem-selection-container",
    { "caprx-f-elem-error": touched && error },
    { "caprx-f-elem-disabled": disabled || readOnly },
    { "caprx-f-elem-read-only": readOnly },
  );

  const inputClasses = classNames({ "caprx-f-elem-radio": type === "radio" }, { "caprx-f-elem-checkbox": type === "checkbox" });

  const testId = id ? "test__selection-" + id.replace(/\s/g, "") : null;

  return (
    <div className={formElemRootClasses}>
      <label htmlFor={id} className={inputClasses} data-testid={testId}>
        <input id={id} type={type} disabled={disabled} {...input} {...rest} />
        <span>{label}</span>
      </label>
      {helperTextEnabled && <div className="caprx-f-elem-helper-text">{setHelperText(helperText, touched, error)}</div>}
    </div>
  );
};

export default Selection;
